import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

const UploadPageFinished = ({
  uploadPageUuid,
  uploadUuid,
  files,
}) => {
  const intl = useIntl();

  return (
    <div className="upload-page-finished">
      <h4 className="upload-title">
        {intl.formatMessage({
          defaultMessage: 'You uploaded {files} {files, plural, one {file} other {files}}',
        }, {
          files,
        })}
      </h4>
      <p>
        <Button tag={Link} to={`/u/${uploadPageUuid}/files/${uploadUuid}`} target="_blank">
          {intl.formatMessage({ defaultMessage: 'View uploaded files' })}
        </Button>
      </p>
    </div>
  );
};

UploadPageFinished.propTypes = {
  uploadPageUuid: PropTypes.string.isRequired,
  uploadUuid: PropTypes.string.isRequired,
  files: PropTypes.number.isRequired,
};

export default UploadPageFinished;
